// src/services/offerService.js
import { apiService } from './api';

export const offerService = {
  // Pour les utilisateurs normaux (offres publiques seulement)
  async getOffers() { // NON UTILISé ///////  a verifier
    const response = await apiService.get('/offers');
    return response.data;
  },

  // Pour l'admin seulement (toutes les offres)
  async getAdminOffers(filters = {}) {
    const params = new URLSearchParams();
    
    if (filters.category) params.append('category', filters.category);
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    
    const url = `/offers/supadmin${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await apiService.get(url);
    return response.data;
  },

  // Détails d'une offre spécifique
  async getOffer(id) {
    const response = await apiService.get(`/offers/${id}`);
    return response.data;
  },


    // Créer une nouvelle entreprise
  async updateOffer(offerId, offerData) {
    const response = await apiService.put(`/offers/supadmin/${offerId}`, offerData);
    return response;
  },
  async createOffer(offerData) {
    const response = await apiService.post(`/offers/supadmin`, offerData);
    return response;
  },

  // Supprimer une proposition
  deleteOffer: async (offerId) => {
    try {
      const response = await apiService.delete(`/offers/supadmin/${offerId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erreur lors de la suppression de la proposition');
    }
  }
};

